import moment from '@g4/moment-utc';
import { DEPARTING, RETURNING } from '../../utils/constants/trackingConstants';
import {
  DEFAULT_FARE_NAME,
  PREMIUM_FARE_NAME,
  ALLEGIANT_FIRST,
  MAIN,
  eventTypes,
} from './constants';

const getFlightsRawProducts = (
  flightList,
  flightSearchCriteria,
  loyaltyPointsDiscount,
  affinityString,
  googleAnalyticsData,
  activeLeg,
  eventType,
  departureFareName,
  returningFareName
) => {
  const rawProducts = [];
  const legs = Object.keys(flightList);
  const {
    adultsCount,
    childrenCount,
    infantCount,
    lapInfantCount,
    tripType,
    departDate,
    returnDate,
  } = flightSearchCriteria;
  let bookingStartDate, bookingEndDate;
  const totalPaxCount =
    adultsCount + childrenCount + infantCount + lapInfantCount;
  const isReturnDiscountTypeAvailable = flightList['returning']?.discountType;
  const isReturnDiscountValueAvailable =
    flightList['returning']?.totalDiscountValue;
  const selectedDepartDate = flightList['departing']?.id?.split('-G4')[0];
  const selectedReturnDate = flightList['returning']?.id?.split('-G4')[0];

  const flightMarketsGAData = {
    departing: googleAnalyticsData?.flightMarkets?.[0],
    returning: googleAnalyticsData?.flightMarkets?.[1],
  };
  const noBundleSelected = eventType === eventTypes.NO_BUNDLE_SELECTED;

  legs.forEach(leg => {
    if (flightList[leg] && (!activeLeg || leg === activeLeg)) {
      const flight = flightList[leg].flight;
      const flightDate = flightList[leg].id.split('-G4')[0];
      const bookingDaysOut = moment(selectedDepartDate).diff(moment(), 'days');
      const operatedBy =
        (flight.operatedBy && flight.operatedBy.carrier) || 'G4';
      const flightNumber = flight.number;
      const route = flight.origin.code + flight.destination.code;
      bookingStartDate = selectedDepartDate ?? departDate?.date;
      bookingEndDate =
        selectedReturnDate ?? returnDate?.date ?? bookingStartDate;
      const discount =
        isReturnDiscountValueAvailable ||
        flightList[leg].totalDiscountValue ||
        0;

      let flightFares = flightList[leg].flightFares || [];
      const iterateAllFares = (!departureFareName && !returningFareName);
      const targetFareName =
        leg === 'departing'
          ? departureFareName
          : leg === 'returning'
            ? returningFareName
            : undefined;
        let faresToIterate;
        if(eventType === eventTypes.REMOVE_FROM_CART) {
          flightFares = [flightList[leg]] || [];
          flightFares.forEach(fare => {
            if (!fare.fareName) {
              fare.fareName = leg === 'departing'
                ? (departureFareName || DEFAULT_FARE_NAME)
                : (returningFareName || DEFAULT_FARE_NAME);
            }
          });
          
          faresToIterate =  flightFares.filter(
            (fare) => fare.fareName === targetFareName
          );
        } else if (noBundleSelected) {
          faresToIterate = flightFares.length ? [flightFares[0]] : [];
        } else if (iterateAllFares || eventType === eventTypes.LIST_VIEW) {
          faresToIterate = flightFares;
        } else {
          faresToIterate = flightFares.filter((fare) => fare.fareName === targetFareName);
        }

      faresToIterate.forEach((fare) => {
        if (!fare) return;
        const fareClassName =
          fare.fareName === DEFAULT_FARE_NAME || noBundleSelected
            ? MAIN
            : fare.fareName === PREMIUM_FARE_NAME
              ? ALLEGIANT_FIRST
              : fare.fareName;
        const rawProduct = {
          item_id:
            route +
            '-' +
            flightNumber +
            '-' +
            flightDate +
            '-' +
            leg[0].toUpperCase() +
            '-' + fareClassName,
          item_name: route +  '-' + fareClassName,
          coupon:
            isReturnDiscountTypeAvailable || flightList[leg].discountType || '',
          discount: discount,
          affiliation: 'WWW - Booking',
          index: 1,
          item_brand: operatedBy,
          item_category: 'Flights',
          item_category2:
            (leg[0].toUpperCase() === 'D' ? DEPARTING : RETURNING) +
            ' ' +
            'Flight',
          item_category3: leg[0].toUpperCase(),
          item_category4: route,
          item_category5: affinityString ? affinityString : 'Air',
          price: fare.price * (adultsCount + childrenCount + infantCount),
          item_variant: `${
            leg[0].toUpperCase() === 'D' ? DEPARTING : RETURNING
          } Flight-${route}-${flightNumber}-${flightDate}` + '-' + fareClassName,
          quantity: 1,
          item_promotion_name: '', // Yet to Decide
          item_loyalty_points_discount:
            (loyaltyPointsDiscount < 0 ? 0 : loyaltyPointsDiscount) || 0,
          item_flight_booking_type: tripType,
          item_booking_start: bookingStartDate,
          item_booking_end: bookingEndDate,
          item_booking_days_out: bookingDaysOut,
          item_count_child: childrenCount,
          item_count_infant: infantCount,
          item_count_lap_child: lapInfantCount,
          item_count_adult: adultsCount,
          item_count_total: totalPaxCount,
          item_round_trip_discount: discount,
        };
        rawProducts.push(rawProduct);
      });
    }
  });
  return rawProducts;
};

export default getFlightsRawProducts;
